import { useMemo } from 'react';
import MovieCard from '@/components/feature/MovieCard';
import SectionHeading from '@/components/feature/SectionHeading';
import type { Movie } from '@/types/movie';

interface HotRecommendationsProps {
  movies: Movie[];
}

export default function HotRecommendations({ movies }: HotRecommendationsProps) {
  const hot = useMemo(
    () => [...movies].sort((a, b) => b.views - a.views).slice(0, 8),
    [movies],
  );

  return (
    <section>
      <SectionHeading
        icon="ri-fire-line"
        title="热门影视推荐"
        subtitle="依据播放量与收藏数精选，正在被大量观看"
      />
      <div className="grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-4">
        {hot.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}